"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactModalDialog = require("react-modal-dialog");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal() {
    (0, _classCallCheck3.default)(this, Modal);
    return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modal, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          isShowingModal = _props.isShowingModal,
          handleClose = _props.handleClose,
          title = _props.title,
          noBottom = _props.noBottom;

      var classNames = "mp-modal-dialog";

      if (!isShowingModal) {
        return null;
      }

      if (noBottom) {
        classNames += " mp-modal-dialog-no-bottom";
      }

      return _react2.default.createElement(
        _reactModalDialog.ModalContainer,
        { className: "mp-modal-container", onClose: handleClose },
        _react2.default.createElement(
          _reactModalDialog.ModalDialog,
          { className: classNames, onClose: handleClose },
          _react2.default.createElement(
            "div",
            { className: "row mp-modal-header" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-8 col-xs-offset-2 mp-modal-header-title" },
              title
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-2 mp-modal-header-button" },
              _react2.default.createElement("i", { className: "icon-mp-close close-icon-js", "aria-hidden": "true", onClick: handleClose })
            )
          ),
          this.props.children
        )
      );
    }
  }]);
  return Modal;
}(_react.Component), _class.propTypes = {
  isShowingModal: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func.isRequired,
  title: _react.PropTypes.string.isRequired,
  children: _react.PropTypes.object.isRequired,
  noBottom: _react.PropTypes.bool
}, _temp);
exports.default = Modal;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/modal/Modal.js
 ** module id = 83
 ** module chunks = 0
 **/